import './sub1.css';
import { Helmet } from "react-helmet";
import { useState, useEffect } from 'react';
import ReactGA from "react-ga4";
import maidservice from '../../images/aboutus.png'
import contactConfig from '../../confi';
export default function About() {
  // Features Data
  const [features] = useState([
    {
      id: 1,
      icon: "🏠",
      title: "Trustworthy Service",
      description: "All our staff undergo thorough background verification and training"
    },
    {
      id: 2,
      icon: "⏰",
      title: "Reliable Support",
      description: "Dedicated customer support for all your queries and concerns"
    },
    {
      id: 3,
      icon: "🔄",
      title: "Easy Replacement",
      description: "Quick and hassle-free replacement if you're not satisfied"
    }
  ]);

  // Support Features Data
  const [supportFeatures] = useState([
    "Background Verified Staff",
    "Professional Training",
    "Regular Quality Checks",
    "Customer Satisfaction Guarantee"
  ]);

  // Services Data
  const [services] = useState([
    {
      id: 1,
      icon: "🧹",
      title: "Home Maid Services",
      description: "Professional cleaning and household maintenance for a spotless home",
      features: ["Daily cleaning", "Deep cleaning", "Kitchen maintenance", "Bathroom cleaning"]
    },
    {
      id: 2,
      icon: "🍳",
      title: "Skilled Cooks",
      description: "Healthy, delicious meals prepared to your taste and dietary requirements",
      features: ["Breakfast preparation", "Lunch & dinner", "Special diet meals", "Party cooking"]
    },
    {
      id: 3,
      icon: "👶",
      title: "Babysitting Services",
      description: "Loving and responsible care for your children with safety first approach",
      features: ["Child care", "Homework assistance", "Playtime supervision", "Feeding & nap time"]
    }
  ]);

  // Additional Services Data
  const [additionalServices] = useState([
    { icon: "👵", name: "Patient Care" },
    { icon: "🏡", name: "Full-time Help" },
    { icon: "⏱️", name: "Part-time Help" },
    { icon: "🌟", name: "Premium Services" }
  ]);

  // Why Choose Us Data
  const [reasons] = useState([
    {
      id: 1,
      number: "01",
      title: "Verified & Trained Staff",
      description: "All our employees undergo thorough background checks and professional training"
    },
    {
      id: 2,
      number: "02",
      title: "Ahmedabad Wide Service",
      description: "Serving all major areas including Bodakdev, Satellite, Thaltej, and more"
    },
    {
      id: 3,
      number: "03",
      title: "Customer First Approach",
      description: "Your satisfaction is our top priority with dedicated support"
    },
    {
      id: 4,
      number: "04",
      title: "Flexible Services",
      description: "Customized packages to suit your specific home care needs"
    }
  ]);


  const handleCall = () => {
    window.open(`tel:${contactConfig.phone}`);
  };

  const handleWhatsApp = () => {
    ReactGA.event("whatsapp_click", {
      page: "About Us",
      section: "Floating Icon",
      button: "WhatsApp",
    });

    const phoneNumber = `${contactConfig.phone}`;
    const message = "Hello, I would like to know more about your services.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/aboutus",
      title: "About Us Page",
    });
  }, []);



  return (
    <div className="main-content-wrapper1">
      <Helmet>
        {/* ---------- SEO BASIC META ---------- */}
        <title>About Us: Reliable House Help Services - JP Home Services</title>
        <meta
          name="description"
          content="Learn about us at JP Home Services. We offer reliable, background-checked maids, cooks & caretakers across Ahmedabad & Surat. Call +918780438907."
        />
        <meta
          name="keywords"
          content="about jp home services, best home services gujarat, maid agency in ahmedabad, cook & babysitter agency, trusted home staff, domestic help provider, home care services gujarat, jp home mission vision"
        />
        <meta name="robots" content="index, follow" />

        {/* ---------- CANONICAL URL ---------- */}
        <link rel="canonical" href="https://jphomeservice.in/aboutus" />

        {/* ---------- OPEN GRAPH (FACEBOOK / LINKEDIN) ---------- */}
        <meta property="og:title" content="About Us: Reliable House Help Services - JP Home Services" />
        <meta
          property="og:description"
          content="Learn about us at JP Home Services. We offer reliable, background-checked maids, cooks & caretakers across Ahmedabad & Surat. Call +918780438907."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://jphomeservice.in/aboutus" />
        <meta
          property="og:image"
          content="https://jphomeservice.in/static/media/aboutus.8b550e39dae1b5add133.png"
        />

        {/* ---------- TWITTER CARD ---------- */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="About Us: Reliable House Help Services - JP Home Services"
        />
        <meta
          name="twitter:description"
          content="Learn about us at JP Home Services. We offer reliable, background-checked maids, cooks & caretakers across Ahmedabad & Surat. Call +918780438907."
        />
        <meta
          name="twitter:image"
          content="https://jphomeservice.in/static/media/aboutus.8b550e39dae1b5add133.png"
        />

        {/* ---------- STRUCTURED DATA (JSON-LD) ---------- */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "JP Home Services",
            "url": "https://jphomeservice.in/aboutus",
            "logo": "https://jphomeservice.in/static/media/TRANSPARNT%20LOGO.1a150556bfeacec71cee.png",
            "image": "https://jphomeservice.in/static/media/aboutus.8b550e39dae1b5add133.png",
            "description": "JP Home Services is a trusted home staffing agency in Gujarat offering verified maids, cooks, babysitters, and elderly care professionals focused on safety, reliability, and excellence.",
            "address": {
              "@type": "PostalAddress",
              "streetAddress": "Vastrapur",
              "addressLocality": "Ahmedabad",
              "addressRegion": "Gujarat",
              "postalCode": "380015",
              "addressCountry": "IN"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "telephone": "+919327365056",
              "contactType": "Customer Service",
              "availableLanguage": ["English", "Hindi", "Gujarati"]
            },
            "sameAs": [
              "https://www.facebook.com/jphomeservice.in/",
              "https://www.instagram.com/jp_home_service/"
            ],
            "foundingDate": "2015",
            "founder": {
              "@type": "Person",
              "name": "JP Home Services Team"
            },
            "serviceType": [
              "Housemaid Services",
              "Cook Services",
              "Babysitter Services",
              "Elderly Care Services",
              "Domestic Help Services"
            ],
            "areaServed": {
              "@type": "Place",
              "name": "Gujarat"
            }
          }
          `}
        </script>
      </Helmet>
      <div className="about">
        {/* Hero Section */}
        <section className="about-hero">
          <div className="hero-content1">
            <h1>About Us</h1>
            <p className="hero-subtitle1">
              Your Trusted Partner in Home Care Services
            </p>
          </div>
        </section>
        <div className="floating-contact-icons">
          <div className="contact-icon whatsapp-icon" onClick={handleWhatsApp}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893c0-3.18-1.24-6.169-3.495-8.424" />
            </svg>
          </div>
          <div
            className="contact-icon call-icon"
            onClick={handleCall}
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
              <path d="M20 10.999h2C22 5.869 18.127 2 12.99 2v2C17.052 4 20 6.943 20 10.999z" />
              <path d="M13 8c2.103 0 3 .897 3 3h2c0-3.225-1.775-5-5-5v2zm3.422 5.443a1.001 1.001 0 00-1.391.043l-2.393 2.461c-.576-.11-1.734-.471-2.926-1.66-1.192-1.193-1.553-2.354-1.66-2.926l2.459-2.394a1 1 0 00.043-1.391L6.859 3.513a1 1 0 00-1.391-.087l-2.17 1.861a1 1 0 00-.29.649c-.015.25-.301 6.172 4.291 10.766C11.305 20.707 16.323 21 17.705 21c.202 0 .326-.006.359-.008a.992.992 0 00.648-.291l1.86-2.171a1 1 0 00-.086-1.391l-4.064-3.696z" />
            </svg>
          </div>
        </div>

        {/* Main About Section */}
        <section className="about-main">
          <div className="container">
            <div className="about-intro">
              <h2>Welcome to JP Home Services</h2>
              <p className="intro-text">
                At <strong>JP Home Services</strong>, we believe every household deserves trustworthy, trained, and professional home support to make daily life easier. With skilled maids, cooks, babysitters, and caretakers, we become a one-stop solution for all your home service needs in Ahmedabad.
              </p>
            </div>

            <div className="about-features">
              <div className="feature-grid">
                {features.map(feature => (
                  <div key={feature.id} className="feature-card">
                    <div className="feature-icon1">{feature.icon}</div>
                    <h3>{feature.title}</h3>
                    <p>{feature.description}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Our Support System Section */}
        <section className="support-section">
          <div className="container">
            <div className="support-content">
              <div className="support-text">
                <h2>Not Just a Service, But a Support System For Your Home</h2>
                <p>
                  We understand that your home is your sanctuary. That's why we provide more than just staff - we offer complete home support solutions tailored to your needs across Ahmedabad's premium neighborhoods.
                </p>
                <div className="support-features">
                  {supportFeatures.map((feature, index) => (
                    <div key={index} className="support-item">
                      <span className="check-icon">✓</span>
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>
              </div>
              <div className="support-images">
                <div className="image-grid">
                  <img src={maidservice} alt="Professional Home Service" />
                  {/* <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQ9T7y_9J0RGKqjX_Q6GGf9coHdma58QMZicg&s" alt="Happy Family" /> */}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Services Section */}
        <section className="services-section">
          <div className="container">
            <h2>Our Comprehensive Services</h2>
            <p className="services-intro">
              At JP Home Services, we provide complete household support with trained and verified staff. From daily cleaning to specialized care, our professionals ensure your home runs smoothly and stress-free.
            </p>

            <div className="services-grid">
              {services.map(service => (
                <div key={service.id} className="service-card">
                  <div className="service-icon">{service.icon}</div>
                  <h3>{service.title}</h3>
                  <p>{service.description}</p>
                  <ul>
                    {service.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>

            <div className="additional-services">
              <h3>Additional Services</h3>
              <div className="additional-grid">
                {additionalServices.map((service, index) => (
                  <div key={index} className="additional-item">
                    <span className="icon">{service.icon}</span>
                    <span>{service.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* Why Choose Us Section */}
        <section className="why-choose-section">
          <div className="container">
            <h2>Why Choose JP Home Services?</h2>
            <div className="reasons-grid">
              {reasons.map(reason => (
                <div key={reason.id} className="reason-card">
                  <div className="reason-number">{reason.number}</div>
                  <h3>{reason.title}</h3>
                  <p>{reason.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}